import { apiClient } from './client.js'

export const fetchChallenges = (summonerName, region, isUpdate) => {
  return apiClient.get('/challenges', {
    params: { summoner: summonerName, region, isUpdate }
  })
}

export const fetchMatchData = (summonerName, region, isUpdate) => {
  return apiClient.get('/match-data', {
    params: { summoner: summonerName, region, isUpdate }
  })
}

export const fetchChampionMastery = (summonerName, region, isUpdate) => {
  return apiClient.get('/champion-mastery', {
    params: { summoner: summonerName, region, isUpdate }
  })
}

export const fetchSearchHistory = () => apiClient.get('/search')

export const fetchTftMatchHistory = (summonerName, region, queue, count) => {
  return apiClient.get('/tft-matches', {
    params: { summoner: summonerName, region, queue, count }
  })
}
